export default {
    API_ENDPOINT: 'https://shrouded-tundra-70540.herokuapp.com',
    
}